import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { RemoveIcon as CrossIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { useBreakpoint } from 'portals-platform-lib';
import BuyerBrandLogo from './BuyerBrandLogo';
import { LogoPlaceholder } from '../styledComponents/LogoPlaceholder';
import { useCompanyAvatarUrl } from '../../contexts/AvatarsContext';
import { getIsPreview } from '../../utils/getIsPreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function BuyerLogoSection({
  isHubSpotUser,
  dealPlanId,
  buyerLogoUrl
}) {
  const isMobile = useBreakpoint() === 'mobile';
  const isPreview = getIsPreview();
  const buyerCompanyAvatarUrl = useCompanyAvatarUrl();
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(View, {
      paddingInline: "200",
      children: /*#__PURE__*/_jsx(CrossIcon, {})
    }), isPreview ? /*#__PURE__*/_jsx(LogoPlaceholder, {
      "data-test-id": "buyer-logo-placeholder",
      isMobile: isMobile
    }) : /*#__PURE__*/_jsx(BuyerBrandLogo, {
      src: buyerLogoUrl !== null && buyerLogoUrl !== void 0 ? buyerLogoUrl : buyerCompanyAvatarUrl,
      isHubSpotUser: isHubSpotUser,
      dealPlanId: dealPlanId
    })]
  });
}